import { Route } from '@angular/router';
import { gamesLocalLeaveBusterGuard } from 'src/app/modules/games/guards/games-local-leave-buster.guard';

export const shanghaiLocalGameRoutes: Route[] = [
    {
        path: 'local-games/shanghai',
        loadComponent: () =>
            import('./pages/shanghai-new-game/shanghai-new-game.component').then((c) => c.ShanghaiNewGameComponent),
    },
    {
        path: 'game/shanghai',
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/shanghai-local-game-app/shanghai-local-game-app.component').then(
                (m) => m.ShanghaiLocalGameAppComponent
            ),
    },
];

export const shanghaiVenueLocalGameRoutes: Route[] = [
    {
        path: 'local-games/shanghai',
        loadComponent: () =>
            import('./pages/shanghai-new-game/shanghai-new-game.component').then((c) => c.ShanghaiNewGameComponent),
    },
    {
        path: 'game/shanghai',
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/shanghai-local-game-venue/shanghai-local-game-venue.component').then(
                (m) => m.ShanghaiLocalGameVenueComponent
            ),
    },
];
